import { useCallback, useState } from "react";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { ShareIcon } from "@heroicons/react/outline";

import ShareClassModal from "./ShareClassModal";

const ShareClassButton = ({
	className,
	course,
	size,
	text,
	variant
}) => {

	const [showModal, setShowModal] = useState(false);
	const toggleShow = useCallback(() => setShowModal((currentShow) => !currentShow), []);

	const onClick = useCallback(() => {
		if ("share" in window.navigator && course.id) {
			const shareData = {
				url: `${window.location.origin}/class/${course.id}`,
				title: course.title
			};
			window.navigator.share(shareData);
		} else {
			toggleShow();
		}
	}, [course]);

	return (
		<>
			<Button
				className={className}
				onClick={onClick}
				size={size}
				variant={variant}
			>
				{text}
				<ShareIcon className="i ms-2" />
			</Button>
			<ShareClassModal course={course} show={showModal} toggleShow={toggleShow} />
		</>
	);
};

ShareClassButton.propTypes = {
	className: PropTypes.string,
	course: PropTypes.shape({
		description: PropTypes.string,
		id: PropTypes.number,
		title: PropTypes.string
	}).isRequired,
	size: PropTypes.string,
	text: PropTypes.string,
	variant: PropTypes.string
};

ShareClassButton.defaultProps = {
	className: "",
	size: "",
	text: "Share This Class",
	variant: "primary"
};

export default ShareClassButton;
